import { useState } from 'react';
import { TradingCustomerModal } from '@/components/trading/customers/customer-modal';
import { SupplierModal } from '@/components/trading/supplier-modal';
import { DealerModal } from './dealer-modal';
import { SaticiModal } from './satici-modal';
import { GenericCariModal } from './generic-cari-modal';
import { isGenericCariType } from './cari-type-display';

interface CariCreateModalsProps {
  /** Cari type code whose create modal is open; null keeps everything closed. */
  createType: string | null;
  /** Display label for generic/custom types (registry name). */
  typeLabel?: string;
  /** Fired when the open modal closes, whether or not a cari was created. */
  onClose: () => void;
}

// Routes a cari type code to its creation modal: dedicated modals for M/T/S/B,
// the generic modal for everything else (built-in generics + custom types).
export function CariCreateModals({ createType, typeLabel, onClose }: CariCreateModalsProps) {
  // Kept after createType clears so the generic modal's title stays stable
  // while its close animation runs. Adjusted during render (not in an effect)
  // so the opening frame never shows the previous type.
  const [generic, setGeneric] = useState<{ type: string; label?: string }>({ type: 'ORT' });
  if (
    createType &&
    isGenericCariType(createType) &&
    (generic.type !== createType || generic.label !== typeLabel)
  ) {
    setGeneric({ type: createType, label: typeLabel });
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) onClose();
  };

  return (
    <>
      <TradingCustomerModal open={createType === 'M'} onOpenChange={handleOpenChange} />
      <SupplierModal open={createType === 'T'} onOpenChange={handleOpenChange} />
      <SaticiModal open={createType === 'S'} onOpenChange={handleOpenChange} />
      <DealerModal open={createType === 'B'} onOpenChange={handleOpenChange} />
      <GenericCariModal
        open={createType !== null && isGenericCariType(createType)}
        cariType={generic.type}
        typeLabel={generic.label}
        onOpenChange={handleOpenChange}
      />
    </>
  );
}
